'use client'

import { BundleSummaryModel } from '@marketplace-web/bundles/items-bundle-data'
import { ProductItemModel } from '@marketplace-web/item-box/product-item-data'
import { EscrowFees } from '@marketplace-web/escrow-pricing/escrow-pricing-data'

import { findThumbnail } from '../../../../utils/photo'
import ServiceFeeIncludedTitle from '../../../ServiceFeeIncludedTitle'

enum ItemThumbnailSize {
  Medium = 'thumb150x210',
}

const getItemPhotoThumbnail = (
  photos:
    | Array<{
        isMain: boolean
        thumbnails: Array<{ type: string; url: string }>
      }>
    | undefined,
  size = ItemThumbnailSize.Medium,
) => {
  const photo = photos?.find(({ isMain }) => isMain)

  return findThumbnail(photo, size)
}

type Props = {
  isSellerBusiness: boolean
  bundleSummary: BundleSummaryModel
  selectedItems: Array<ProductItemModel>
  escrowNoteTranslationKey?: string
}

const DetailedPriceBreakdown = ({
  bundleSummary,
  isSellerBusiness,
  selectedItems,
  escrowNoteTranslationKey,
}: Props) => {
  const { price, buyerProtectionFee, priceWithBuyerProtectionFee } = bundleSummary
  const selectedItemIds = selectedItems.map(({ id }) => id)
  const firstItem = selectedItems[0]
  const isBundle = selectedItems.length > 1
  const commonProps = {
    itemId: selectedItemIds[0]!,
    isSellerBusiness,
    shouldTrimTitle: true,
    shouldMinimiseTitle: true,
    itemPrice: price,
    serviceFee: buyerProtectionFee,
    totalItemPrice: priceWithBuyerProtectionFee,
  }

  if (!firstItem) {
    return <ServiceFeeIncludedTitle {...commonProps} isDisabled />
  }

  const detailedBreakdownProps = {
    itemTitle: firstItem.title,
    itemPhotoSrc: getItemPhotoThumbnail(firstItem.photos),
  }

  // Passing data from bundle summary instead of fetching from escrow fees endpoint for now.
  // At the moment there is not support for multiple item id fetching for escrow fees
  const detailedBreakdownPropsBundle = {
    ...detailedBreakdownProps,
    itemsCount: selectedItems.length,
    escrowFees: {
      buyerProtection: {
        finalPrice: buyerProtectionFee,
        discount: null,
        type: EscrowFees.BuyerProtection,
        isFee: Number(buyerProtectionFee.amount) > 0,
        originalPrice: buyerProtectionFee,
      },
    },
  }

  return (
    <ServiceFeeIncludedTitle
      {...commonProps}
      detailedBreakdown={isBundle ? detailedBreakdownPropsBundle : detailedBreakdownProps}
      escrowNoteTranslationKey={escrowNoteTranslationKey}
    />
  )
}

export default DetailedPriceBreakdown
